import {
  FilterLabels,
  FilterSelectedValue,
  FilterType,
} from '@aboutyou/legacy-tracking-sdk';
import {
  FilterDropdownMultipleBoolean,
  GenericIconName,
} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {
  YourDealsInterface,
  useYourDealsSection,
} from '../../shared/useYourDealsSection';
import {FilterSectionBoolean} from './FilterSectionBoolean';

type Props = {
  resetFilters: (slug: string[]) => void;
  onOpen: (
    filterSlug: string,
    label: FilterLabels,
    selectedValue: FilterSelectedValue,
    filterType: FilterType,
  ) => void;
  onClose: (
    filterSlug: string,
    label: FilterLabels,
    selectedValue: FilterSelectedValue,
    filterType: FilterType,
  ) => void;
};

export const FilterSectionYourDeals: FC<YourDealsInterface & Props> = ({
  activeFilters,
  data,
  resetFilter,
  resetFilters,
  setFilter,
  setFilters,
  onOpen,
  onClose,
}) => {
  const {booleanFilters, onToggleFilterContent, onResetYourDealsFilter} =
    useYourDealsSection({
      activeFilters,
      data,
      resetFilter,
      setFilters,
      resetFilters,
    });

  if (!data.discount) {
    return (
      <FilterSectionBoolean
        activeFilters={activeFilters}
        data={{
          label: data.sale.headline,
          slug: data.sale.slug,
        }}
        setFilter={setFilter}
        resetFilter={resetFilter}
      />
    );
  }

  return (
    <FilterDropdownMultipleBoolean
      label={data.label}
      onToggleFilterContent={onToggleFilterContent}
      booleanFilters={booleanFilters}
      displayIcon={GenericIconName.Sale}
      onFilterReset={onResetYourDealsFilter}
      onOpen={() =>
        onOpen('hasCampaignReduction', 'quick_filters', true, 'boolean')
      }
      onClose={() =>
        onClose('hasCampaignReduction', 'quick_filters', false, 'boolean')
      }
    />
  );
};
